import * as Sentry from '@sentry/react'

const sentryDebug = () => {
  const logToSentry = (eventType, payload) => {
    const { event, properties, meta } = payload

    Sentry.withScope(scope => {
      scope.setTag('ga4_debug', true)
      scope.setTag('ga4_event_type', eventType)
      scope.setTag('ga4_event_name', event || 'PageView')
      scope.setLevel('info')

      scope.setContext('ga4_event', {
        event: event || 'PageView',
        eventType,
        properties,
        timestamp: meta?.timestamp || new Date().toISOString(),
        url: window.location.href,
        ga4Id:
          document.querySelector('meta[name="google-analytics-id"]')?.content ||
          'not configured',
      })

      Sentry.captureMessage(`[GA4 Debug] ${eventType}: ${event || 'PageView'}`)
    })

    console.log(`[SentryDebug] Logged ${eventType} event:`, event, properties)
  }

  return {
    name: 'sentry-debug',
    config: {},
    initialize: () => {
      console.log('[SentryDebug] Plugin initialized')
    },
    page: ({ payload }) => {
      logToSentry('PAGE_VIEW', {
        event: 'PageView',
        properties: { url: window.location.href, title: document.title },
        meta: payload.meta,
      })
    },
    track: ({ payload }) => {
      logToSentry('TRACK', payload)
    },
    identify: ({ payload }) => {
      logToSentry('IDENTIFY', {
        event: 'Identify',
        properties: payload.traits,
        meta: payload.meta,
      })
    },
    loaded: () => true,
  }
}

export default sentryDebug
